import axios from "axios";

// RSPEC IS NOT WAITING FOR AXIOS REQUESTS TO FINISH WORKAROUND FOR wait_for_ajax
if (process.env.RAILS_ENV == "test") {
  window.pendingRequestCount = 0;
}

const updatePendingRequestCount = (value) => {
  if (typeof window.pendingRequestCount === 'number') {
    window.pendingRequestCount = window.pendingRequestCount + value;
  }
}

api = axios.create({
  headers: {
    Accept: "application/json",
    "Content-type": "application/json",
  },
});

const csrfToken = () => (document.querySelector("meta[name='csrf-token']")?.content || "");

api.interceptors.request.use(
  config => {
    config.headers['X-CSRF-Token'] = csrfToken();
    updatePendingRequestCount(1);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    updatePendingRequestCount(-1);
    return response;
  },
  (error) => {
    updatePendingRequestCount(-1);
    return Promise.reject(error);
  }
);

export default api;
